var React = require('react');

function ChevronBold (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.9 1.5l58.6 58.7c1 .9 1.5 2.2 1.4 3.5a5 5 0 0 1-1.4 3.5l-58.6 58.7c-1 1-2.3 1.5-3.7 1.5-1.4 0-2.6-.6-3.5-1.5L1.5 113a5.1 5.1 0 0 1-1.5-3.5c0-1.4.6-2.6 1.5-3.5l42.1-42.1L1.5 21.7c-1-.9-1.5-2.2-1.5-3.5 0-1.3.6-2.5 1.5-3.5L14.7 1.5C15.6.6 16.8 0 18.2 0s2.6.6 3.7 1.5z"}));
}

ChevronBold.defaultProps = {"viewBox":"0 0 81.9 127.7"};

module.exports = ChevronBold;

ChevronBold.default = ChevronBold;
